import { CheckCircle, Lightbulb, Plug } from "lucide-react";
import React from "react";
import { Button } from "src/components/ui/button";
import { Card } from "src/components/ui/card";
import { getBrandThemeFromDomain, getProductName } from "src/utils/brandTheme";

interface SuccessCardType {
  title: React.ReactNode;
  body: React.ReactNode;
  icon: React.ReactNode;
}

export default function SlackConnectSuccess() {
  const productName = getProductName(getBrandThemeFromDomain());

  const cards: SuccessCardType[] = [
    {
      icon: <Lightbulb className="h-5 w-5" />,
      title: "Tip: Investigate customer issues",
      body: <>Tag {productName} on an alert or customer issue to kick off an investigation.</>,
    },
    {
      icon: <Lightbulb className="h-5 w-5" />,
      title: "Tip: Follow-up on alert investigations",
      body: <>Tag {productName} on an alert thread to dig deeper or ask follow-up questions. Sharing more context helps {productName} build knowledge for future investigations.</>,
    },
    {
      icon: <Lightbulb className="h-5 w-5" />,
      title: <>Tip: Connect {productName} MCP</>,
      body: <>Connect {productName} MCP to bring production context to your development environment.</>,
    },
  ];

  return (
    <div className="min-h-screen bg-background text-foreground flex items-center justify-center p-6 relative">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,rgba(59,130,246,0.08)_0%,rgba(0,0,0,0)_50%)] pointer-events-none" />
      <div className="w-full max-w-5xl flex flex-col items-center gap-8 relative">
        <div className="flex flex-col items-center text-center gap-2">
          <CheckCircle className="h-10 w-10 text-primary" />
          <h2 className="text-2xl font-medium text-foreground">Successfully linked!</h2>
          <p className="text-sm text-muted-foreground">
            Your Slack account has been linked to {productName}.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 w-full">
          {cards.map((card, index) => (
            <Card key={index} className="p-5 flex flex-col gap-2">
              <div className="flex items-center gap-2 text-foreground">
                <span className="text-primary flex-shrink-0">{card.icon}</span>
                <h3 className="text-sm font-medium tracking-tight">{card.title}</h3>
              </div>
              <p className="text-xs text-muted-foreground leading-relaxed">{card.body}</p>
            </Card>
          ))}
        </div>

        <Button
          variant="primary"
          size="lg"
          onClick={() => {window.location.href="/mcp"}}
        >
          <Plug className="h-4 w-4 mr-1 -ml-3" />
          Next: Connect {productName} MCP
        </Button>
      </div>
    </div>
  );
}
